// eslint-disable-next-line import/prefer-default-export
export const ObjectToQuery = o => {
  const data = [];
  function iter(o, path) {
    if (Array.isArray(o)) {
      o.forEach(a => {
        iter(a, `${path}[]`);
      });

      return;
    }
    if (o !== null && typeof o === 'object') {
      Object.keys(o).forEach(k => {
        iter(o[k], `${path}[${k}]`);
      });

      return;
    }
    data.push(`${path}=${o}`);
  }

  Object.keys(o).forEach(k => {
    iter(o[k], k);
  });

  return data.join('&');
};
